/*
|--------------------------------------------------------------------------
| TypeAhead Fields
|--------------------------------------------------------------------------
|
| This file contains:
| - Typeahead input initializers
| - Search/autocomplete configurations
| - Data-driven lookup bindings (AJAX/local sources)
| - Context-aware field enhancements
|
| These functions should:
| - Accept $context
| - Be idempotent (safe to call multiple times)
| - Initialize based on data-* attributes
| - Do nothing if matching elements do not exist
|
| This file should NOT contain:
| - Business logic
| - Page-specific behavior
| - Hardcoded selectors outside of scoped initialization
|
| Think: "Turn this input into an autocomplete/search experience."
|
*/

function BindTypeAheads($context: JQuery<any>): void
{
    const $inputs = $context.findInGrid("[data-typeahead-url]");

    if ($inputs.length === 0)
    {
        return;
    }

    $inputs.each(function ()
    {
        const $input = $(this);

        InitializeTypeAhead($input);
    });
}

function InitializeTypeAhead($input: JQuery<any>): void
{
    const url = $input.data("typeahead-url") as string | undefined;

    if (!url)
    {
        return;
    }

    const minLength = Number($input.data("typeahead-minlength") ?? 1);
    const hint = $input.data("typeahead-hint") !== false;
    const highlight = $input.data("typeahead-highlight") !== false;

    const separator = url.includes("?") ? "&" : "?";

    const engine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: `${url}${separator}searchText=%QUERY`,
            wildcard: "%QUERY",
            cache: false,
            rateLimitBy: "debounce",
            rateLimitWait: 300,
            transform: function (response: any[]) {
                //console.log("REMOTE RESPONSE:", response);
                return response;
            }
        }
    });

    $input.typeahead(
        {
            hint: hint,
            highlight: highlight,
            minLength: minLength
        },
        {
            name: "default-typeahead",
            source: engine.ttAdapter(),
            limit: 10
        }
    );
}